import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import environmentVariables from '../../config/environmentVariables';
import editicon from "../../Images/editicon.png"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';

const Address = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  font-size: 20px;
  color: #ffffff;
  font-family: Lato;
  font-weight: 400;
  margin-top: 5px;
  word-break: break-all;
  @media (max-width:1350px) {
    font-size: 18px;
  }
  @media (max-width: 1200px) {
    font-size: 16px;
  }
  @media (max-width: 1000px) {
    font-size: 14px;
  }
  @media (max-width: 600px) {
    font-size: 12px;
  }
  @media (max-width: 400px) {
    font-size: 10px;
  }
  @media (max-width: 300px) {
    font-size: 9px;
  } 
`;

const ProfileContainer = styled.div`
  background-color: #0f1317;
  color: white;
  text-align: center;
  padding: 60px 20px;
  font-family: 'Open Sans', sans-serif;
  position: relative;
  height: 700px;
  margin: 0 auto;
  width: 85%;
`;

const CopyIcon = styled.div`
  color: white;
  cursor: pointer;
  padding: 0 10px 0 0;
  @media (max-width: 425px) {
    padding: 0 5px 0 5px;
  }
`;

const MetaLogo = styled.div`
  font-size: 115px;
  font-weight: bold;
  color: rgb(23 41 48 / 40%);
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-family: SweraDemo;
  user-select: none;
  z-index: 0;
  @media (max-width:1350px) {
    font-size: 90px;
  }
  @media (max-width: 1200px) {
    font-size: 80px;
  }
  @media (max-width: 1000px) {
    font-size: 60px;
  }
  @media (max-width: 600px) {
    font-size: 40px;
  }
  @media (max-width: 400px) {
    font-size: 30px;
  }
  @media (max-width: 300px) {
    font-size: 20px;
  }
`;

const AvatarWrapper = styled.div`
  position: relative;
  display: inline-block;
  z-index: 1;
  margin-top: 60px;
`;

const AvatarImage = styled.img`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  border: 2px solid #00bcd4;
  height: 150px;
  width: 150px;
  @media (max-width:1350px) {
    height: 120px;
    width: 120px;
  }
  @media (max-width: 1200px) {
    height: 100px;
    width: 100px;
  }
  @media (max-width: 1000px) {
    height: 80px;
    width: 80px;
  }
  @media (max-width: 600px) {
    height: 60px;
    width: 60px;
  }
  @media (max-width: 400px) {
    height: 50px;
    width: 50px;
  }
  @media (max-width: 300px) {
    height: 40px;
    width: 40px;
  }
`;
const AvatarFallback = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 2px solid #00bcd4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
  font-weight: bold;
  background-color: #1f2937;
  color: #ffffff;
  @media (max-width:1350px) {
    height: 120px;
    width: 120px;
    font-size: 50px;
  }
  @media (max-width: 1200px) {
    height: 100px;
    width: 100px;
    font-size: 40px;
  }
  @media (max-width: 1000px) {
    height: 80px;
    width: 80px;
    font-size: 32px;
  }
  @media (max-width: 600px) {
    height: 60px;
    width: 60px;
    font-size: 26px;
  }
  @media (max-width: 400px) {
    height: 50px;
    width: 50px;
    font-size: 22px;
  }
  @media (max-width: 300px) {
    height: 40px;
    width: 40px;
    font-size: 18px;
  }
`;

const EditIcon = styled.div`
  cursor: pointer;
  position: absolute;
  bottom: 0;
  right: 0;
  /* background-color: #1f2937; */
  border-radius: 50%;
  padding: 4px;
  /* border: 2px solid white; */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  font-size: 12px;
  @media (max-width:1350px) {
    width: 43px;
    height: 43px;
  }
  @media (max-width: 1200px) {
    width: 41px;
    height: 41px;
  }
  @media (max-width: 1000px) {
    width: 28px;
    height: 28px;
  }
  @media (max-width: 600px) {
    width: 26px;
    height: 26px;
  }
  @media (max-width: 400px) {
    width: 24px;
    height: 24px;
  }
  @media (max-width: 300px) {
    width: 20px;
    height: 20px;
  }
`;
const EditIconImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
 
`;


const UserName = styled.div`
  margin-top: 5px;
  font-size: 32px;
  font-weight: 600;
  font-family: Lato;
  text-transform: capitalize;
  color: #ffffff;
  @media (max-width:1350px) {
    font-size: 28px;
  }
  @media (max-width: 1200px) {
    font-size: 24px;
  }
  @media (max-width: 1000px) {
    font-size: 20px;
  }
  @media (max-width: 600px) {
    font-size: 18px;
  }
  @media (max-width: 400px) {
    font-size: 16px;
  }
  @media (max-width: 300px) {
    font-size: 14px;
  }
`;

const Email = styled.div`
  font-size: 22px;
  color: #ffffff;
  font-family: Lato;
  font-weight: 400;
  margin-top: 5px;
  @media (max-width:1350px) {
    font-size: 20px;
  }
  @media (max-width: 1200px) {
    font-size: 18px;
  }
  @media (max-width: 1000px) {
    font-size: 16px;
  }
  @media (max-width: 600px) {
    font-size: 14px;
  }
  @media (max-width: 400px) {
    font-size: 12px;
  }
  @media (max-width: 300px) {
    font-size: 10px;
  } 
`;

const FieldHeading = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #a0a0a0;
  margin-top: 15px;
  @media (max-width:1350px) {
    font-size: 15px;
  }
  @media (max-width:1200px) {
    font-size: 14px;
  }
  @media (max-width:1000px) {
    font-size: 13px;
  }
  @media (max-width:600px) {
    font-size: 12px;
  }
  @media (max-width:400px) {
    font-size: 11px;
  }
`;

const FieldContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;



const ProfileCard = ({data,allContractDetails,fetchProfileInformation}) => {
  const inputRef=useRef(null);
  const copyRef = useRef(null);
  const copyAddress = async () => {
    try {
      if(copyRef.current){
        await navigator.clipboard.writeText(allContractDetails?.address);
        toast.success("Address copied!",{autoClose:2000});
      }else{
        toast.error("Failed to copy address.",{autoClose:2000});
      }
    }catch (err) {
      console.error("Failed to copy address: ", err);
      toast.error("Failed to copy address.",{autoClose:2000});
    }
  }
  const [imageError,setImageError] = useState(false)
  const navigate = useNavigate(null);
  useEffect(()=>{
    if(!allContractDetails?.address ){
      navigate("/");
    }
  },[allContractDetails])
  const handleEditImage = () => {
    Swal.fire({
      title:"Do you want to edit or delete profile picture?",
      showDenyButton:true,
      showCancelButton:true,
      confirmButtonText:"Edit",
      denyButtonText:"Delete",
    }).then(result=>{
      if(result.isConfirmed){
        if (inputRef.current)
      inputRef.current.click();
       else
        toast.error("Error editing profile, please try again")
    }else if(result.isDenied){
      let config = {
        method:"POST",
        url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/delete/user/profile/${allContractDetails?.address}`
      }
      axios.request(config).then(response=>{
        if(response?.data?.success==true){
          toast.success("profile picture deleted!!!")
          fetchProfileInformation(allContractDetails?.address)
        }else{
          toast.error("Failed to delete profile picture")
        }
      }).catch(error=>{
        console.log(error,'error in deleting profile')
        toast.error("Failed to delete profile picture")
      })
    }
    })
  }
  const handleChangeInputFile=(e)=>{
    try{
      const file = e.target.files[0];
      if (file) {
        // console.log("Selectedfile------------------------------------------>", file);
        if(file?.type !== "image/png" && file.type !== "image/jpeg"){
          toast.error("Invalid file (PNG or JPEG only).");
          return;
        }
        if(file.size > 5 * 1024 * 1024) { // 5MB limit
          toast.error("File size exceeds limit (5MB).");
          return;
        }
        const formData = new FormData();
        formData.append('profile', file);
        let config = {
          method: 'POST',
          data: formData,
          url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/upload/user/profile/${allContractDetails?.address}`,
        };
        axios.request(config)
          .then((response) => {
            if(response?.data?.success == true){
              toast.success("Profile image updated.");
              fetchProfileInformation(allContractDetails?.address);
            }else{
              toast.error("Failed to update profile image.");
            }
          })
          .catch((error) => {
            console.error("Error uploading profile image:", error);
            toast.error("Error uploading profile image.");
          });
      }else{
        toast.error("Please select a file to upload.");
      }
    }catch(err){
      console.error("Error in handleChangeInputFile: ", err);
    }
  }
  return (
    <ProfileContainer>
      <MetaLogo>METASPACE</MetaLogo>
      <AvatarWrapper>
        {data?.profileImage&&imageError==false?<AvatarImage src={`${environmentVariables?.apiUrl}/${data?.profileImage}`} alt="User Avatar" onError={()=>setImageError(true)} />:<AvatarFallback>{data?.name.slice(0, 1)?data?.name.charAt(0).toUpperCase():data?.email.charAt(0).toUpperCase()}</AvatarFallback>}
        <EditIcon onClick={handleEditImage}><EditIconImage src={editicon}/></EditIcon>
      </AvatarWrapper>
      <FieldContainer>
  <FieldHeading>Username</FieldHeading>
  <UserName>{data?.name}</UserName>
</FieldContainer>

<FieldContainer>
  <FieldHeading>Email</FieldHeading>
  <Email>{data?.email}</Email>
</FieldContainer>

<FieldContainer>
  <FieldHeading>Address</FieldHeading>
  <Address>
    <div>
      <CopyIcon onClick={copyAddress}>
        <i className="fa-solid fa-copy"></i>
        <ToastContainer position="top-left" />
      </CopyIcon>
    </div>
    <div ref={copyRef}>{allContractDetails?.address}</div>
  </Address>
</FieldContainer>
      <input onChange={handleChangeInputFile} type='file' id='file' ref={inputRef} style={{display:"none"}}/>
    </ProfileContainer>
  );
};

export default ProfileCard;
